class FilterDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('.drawer__overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    const closeButton = this.querySelector('.drawer__close');
    if (closeButton) closeButton.addEventListener('click', this.close.bind(this));

    const applyButton = this.querySelector('#FilterDrawerApply');
    if (applyButton) applyButton.addEventListener('click', this.close.bind(this));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => this.classList.add('animate', 'active'));

    this.addEventListener('transitionend', () => {
      trapFocus(this.querySelector('.drawer__inner'), this.querySelector('.drawer__close'));
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('filter-drawer', FilterDrawer);
